import Plyr from 'plyr';
import { debounce as _debounce } from 'underscore';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin( ScrollTrigger);

// Vimeo Player SDK:  https://developer.vimeo.com/player/sdk
const console = window.console;

export default class{

    constructor( options ) {
        this.defaults = {
        	$el: false,
        	index: 0,
        	trackGAEvents: true,

        	scrollaAutopause: false,
        	debug: false
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'embed_plyr_player';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;

		this.$window 		= 	$(window);

		this.init( true );
    }

    init( b ){
    	this.$iframe = this.$el.find( 'iframe' );

    	/*
    	if ( this.$iframe.length <= 0 ){
    		this.onError(  {name: 'missing element', message:'iframe is missing'} );
    		return;
    	}
		*/

    	if ( !this.$el.hasClass( 'is-plyr') ){


	    	if ( this.$iframe.length <= 0 ){
	    		this.onError(  {name: 'missing element', message:'iframe is missing'} );
	    		return;
	    	}


    		this.options.autopause = false;
    		// just resize the embed
    		this.debounceResize(b);

    		if ( b ){
    			if ( this.$el.hasClass( 'has-poster' ) ){
    				this.$el.on( 'click', () => this.revealVideoPoster() );
    			}
    		}

    		return;
    	}


    	this.initPlayer( b );
    	// this.addEvents( b );

		// if the placeholder (video-poster) is specified, set video embed to visible
		if ( this.$el.find( '.placeholder' ).length > 0 ){
			this.$el.addClass( 'video-load' );
		}    	
	}

	revealVideoPoster(){
		this.$el.off( 'click', () => this.revealVideoPoster() );
		gsap.to( this.$el.find( 'img' ), {opacity:0,duration:0.3,onComplete:()=>{
			this.$el.find( 'img' ).remove()
		}} );
		gsap.to( this.$el.find( 'svg' ), {opacity:0,duration:0.3,onComplete:()=>{
			this.$el.find( 'svg' ).remove()
		}} );
		this.$el.removeClass( 'has-poster' )
	}

	initPlayer( b ){
		if ( b ){

			this.eliminate_CA_Junk();
			

            let base = $( 'body' ).attr( 'data-theme-url' ) ? $( 'body' ).attr( 'data-theme-url' ) : 'https://cfarchives.wpengine.com/wp-content/themes/Chicago-Film-Archives',

            	iconUrl =  base + '/assets/img/plyr/plyr.svg',

            	params = {
	                debug: this.options.debug,
	                iconUrl: iconUrl,
	                //controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen'],
	                controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
	                fullscreen: { enabled: true, fallback: true, iosNative: true, container: null },

	                disableContextMenu: false
            	};

            //console.log( 'videoEmbedPlayer INIT, iconUrl = ' +  iconUrl );

			const player = new Plyr( this.$el.find( '.plyr__video-embed' ), params);
			this.player = player;
            // This needs to be called AFTER we set up player

			//setTimeout( ()=>this.$el.addClass( 'ready' ), 1000 );

            this.addEvents( b );
		}
		else{
            // This needs to be called BEFORE we destroy player
            this.addEvents( b );
			
			//console.log('>>> videoPlayerEmbed initPlayer/false');
			
			if ( this.player){
				this.player.destroy();
				this.player = null;
			}
		}
		this.initScrollAutoPause(b)
	}

	eliminate_CA_Junk(){
		let $junk = this.$el.parent();

		// remove if video is wrapped on a #caMediaOverlayContent
		if ( $junk.attr( 'id' ) === 'caMediaOverlayContent' ){
			this.$el.unwrap();
			$junk.remove();
			$junk = $( '.caMediaOverlayControls' );
			if ( $junk.length > 0 ){
				$junk.remove()
			}
			// remove if video is wrapped on a .img-wrapper
			$junk = this.$el.parent();
			if ( $junk.hasClass( 'img-wrapper' ) ){
				this.$el.unwrap();
				$junk.remove();
			}
		}
	}

	initScrollAutoPause( b ){
		if ( ! this.options.scrollAutopause ){
			return;
		}


		if ( b ){
			this.scrollTriggerId = this.namespace + '_' + Math.random();
			
			ScrollTrigger.create({
				id: this.scrollTriggerId
				,scrub: true
				,trigger: this.$el
				,toggleClass: 'auto-in-view'
				,scroller: $(this.main.options.$scroll_el)
				,onToggle: (e) => {
					//console.log( e );
					this.forceAutoPause( !e.isActive );
				}
				//,markers: true
			});
		}
		else{
			ScrollTrigger.getById( this.scrollTriggerId ).kill();
		}
	}

	 //---------------------------------------- EVENTS ---------------------------------------//
	addEvents( b ){
		const player = this.player;
		if ( b ){
			player.on('ready', (event) => {
	  			//const instance = event.detail.plyr;
				setTimeout( ()=>this.onReadyPlyrRatio(), 1000 );

				this.$el.addClass( 'ready' );  

			});
			player.on('play', (event) => {
		    	if ( this.options.trackGAEvents ){
					this.main.setGAEvent(  'Video Play', 'Click', this.$iframe.attr( 'src' ) , document.location.href  );
		    	}
		    	this.main.WIDGETS.pauseVideoPlayersIfPlaying( this.options.index );
			});
			player.on('pause', (event) => {
		    	if ( this.options.trackGAEvents ){
					this.main.setGAEvent(  'Video Pause', 'Click', this.$iframe.attr( 'src' ) , document.location.href  );
		    	}
			});
		}
		else{
			
			//console.log('>> videoPlayerEmbed addEvents/off::', player);
			
			player.off('ready', (event) => {
	  			//const instance = event.detail.plyr;
				//console.log( 'PLYR READY' );
				//console.log( event );
			});
			player.off('play', (event) => {
		    	if ( this.options.trackGAEvents ){
					this.main.setGAEvent(  'Video Play', 'Click', this.$iframe.attr( 'src' ) , document.location.href  );
		    	}
		    	this.main.WIDGETS.pauseVideoPlayersIfPlaying( this.options.index );
			});
			player.off('pause', (event) => {
		    	if ( this.options.trackGAEvents ){
					this.main.setGAEvent(  'Video Pause', 'Click', this.$iframe.attr( 'src' ) , document.location.href  );
		    	}
			});
		}
		this.debounceResize(b);
	}

    debounceResize( b ){
		if ( b ){
			// debounce resize
			this._debResize = _debounce( () => {
				this.onResize();
			}, 77 );
			this.$window.on( 'resize', this._debResize );

			this.onResize()
		}
		else{
			if ( this._debResize ){
				this._debResize.cancel();
				this.$window.off( 'resize', this._debResize );
			}        
		}
    }

    onError( error ){
    	let str = this.namespace + ' : ';
		switch (error.name) {
			case 'PasswordError':
				str += 'The video is password-protected';
			break;
			case 'PrivacyError':
				str += 'The video is private';
			break;
			default:
				str += error.message;
		}
		//console.log( error );
		//console.log( str );
    }

    onReadyPlyrRatio(){
    	this.resizeToItsRatio();
    }

    resizeToItsRatio(){
    	let player = this.player, w, h, r, $el;
    	if ( player.ratio ){
    		r = player.ratio.split( ':' );
    		w = parseInt( r[0] );
    		h = parseInt( r[1] );
    		$el = this.$el.find( '.plyr' );
    		if ( $el.length > 0 ){
    			$el.css({
    				'aspect-ratio' : w + '/' + h
    			})    			
    		}
    	}
    }

    onResize(){
    	const w_video = parseInt( this.$iframe.attr('width')  ), 
    		  h_video = parseInt( this.$iframe.attr('height') );
    	
    	let $wrapper  = this.$el.find( '.video-wrapper' );


    	// resize the normal embed if it's not the plyr
    	if ( !this.$el.hasClass( 'is-plyr') ){
    		if ( $wrapper.length > 0 && h_video && w_video ){
    			$wrapper.css({
    				'padding-bottom' : (100*h_video/w_video) + '%'
    			})
    		}
    	}

    	//console.log( w_video + ',' + h_video );

		if ( this.options.autopause ){
			ScrollTrigger.refresh();
		}
    }

    //---------------------------------------- METHODS ---------------------------------------//
    play( b ){
    	if ( !this.player) return;
    	
    	if ( b ){
    		this.player.play();
    	}
    	else{
    		this.player.stop();
    	}
	}

	pause(){
		if ( !this.player) return;
		this.player.pause();
	}

    togglePlay(){
		if ( !this.player) return;
		this.player.togglePlay();
    }

    pauseIfPlaying(){
    	if ( !this.player) return;
    	if ( this.player.playing ){
    		this.pause();
    	}
    }

    // fired by ScrollTrigger if this.options.autopause is true
    forceAutoPause( b ){
    }

    destroy(){
    	this.init( false );
    }

}


